import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import { typographyStyles, IconButton, Button } from '@livecommerce/design-system';
import { useTopbar } from 'contexts/TopbarContext.jsx';

const { getBodyText } = typographyStyles;

const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: ${(props) => (props.hasCenterContent ? '1fr 2fr 1fr' : 'auto auto')};
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  min-height: 0;
  padding: 16px;
`;

const LeftContent = styled.div`
  gap: 12px;
  display: flex;
  align-items: center;
  min-width: 0;

  p {
    margin: 0;
  }
`;

const CenteredContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${getBodyText(16)};
  margin: 10px 0;
`;

const backButtonStyle = css`
  padding: 7px;
`;

const Topbar = (props) => {
  const {
    title,
    dataTestId,
    backButton,
    backButtonLabel,
    onBackButtonClick,
    actionsContent,
    leftContent,
    centerContent,
  } = useTopbar();

  const commonButtonProps = {
    size: 'medium',
    variant: 'transparent',
    iconName: 'back',
    as: onBackButtonClick ? 'button' : Link,
    to: backButton,
    onClick: onBackButtonClick,
  };

  const hasSomeContent = title || leftContent || centerContent || actionsContent || backButton || onBackButtonClick;
  if (!hasSomeContent) return null;

  return (
    <Container {...props} hasCenterContent={Boolean(centerContent)}>
      <LeftContent data-testid="leftContent">
        {(backButton || onBackButtonClick) && backButtonLabel && (
          <Button className={backButtonStyle} isUppercase={false} {...commonButtonProps}>
            {backButtonLabel}
          </Button>
        )}
        {(backButton || onBackButtonClick) && !backButtonLabel && <IconButton {...commonButtonProps} />}
        {title && <Title data-test-id={dataTestId}>{title}</Title>}
        {leftContent ? leftContent : null}
      </LeftContent>
      {centerContent && <CenteredContent>{centerContent}</CenteredContent>}
      {actionsContent}
    </Container>
  );
};

export default Topbar;
